<script setup>
import PasswordResetForm from "@/forms/PasswordResetForm.vue";

definePage({
    meta: {
        layout: 'guest'
    }
})
</script>

<template>
    <password-reset-form />
</template>
